import React from 'react';
import LegalDocumentModal from 'components/LegalDocumentModal/LegalDocumentModal';

export default function PrivacyPolicy() {
    return (
        <LegalDocumentModal
            kind="pop"
            titleKey="privacy_policy"
        />
    );
}
